import { useFormErrorNotification } from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { ShopDto } from "../generated/schema";

type UseAskAIParams = {
	shop: ShopDto;
};

export function useAskAI({ shop }: UseAskAIParams) {
	const mutation = $api.useMutation("post", "/shops/{shopId}/ask");

	const errorNotification = useFormErrorNotification();

	return useMutation({
		onError: () => errorNotification(),
		mutationFn: async (content: string) => {
			return mutation.mutateAsync({
				params: { path: { shopId: shop.id } },
				body: { query: content },
			});
		},
	});
}
